export default "__VITE_ASSET__TtX5tOdA__"